import { Formik, useFormik } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function Register() {
  const baseURL = "https://ecommerce.routemisr.com"; // or 'https://route-ecommerce-app.vercel.app'
  // validation manually
  // function validate(values) {
  //   let errors = {}
  //   if (!values.name) {
  //     errors.name = 'Name is Required'
  //   }else if (values.name.length < 3) {
  //     errors.name = 'Name minlength is 3 chars'
  //   }else if (values.name.length > 10) {
  //     errors.name = 'Name maxlength is 10 chars'
  //   }
  //   if (!values.email) {
  //     errors.email = 'Email is Required'
  //   }else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
  //     errors.email = 'Invalid email address *exemple@yyy.zzz';
  //   }
  //   if (!values.password) {
  //     errors.password = 'Password is required'
  //   } else if (!/^[A-Z][a-z0-9]{5-10}$/i.test(values.password)) {
  //     errors.password = 'Password must start with Capital Letter, at least 5 and less than 10 characters '
  //   }
  //   if (!values.rePassword) {
  //     errors.rePassword = 'Please reEnter Your Password'
  //   }else if (values.rePassword !== values.password) {
  //     errors.rePassword = 'Confirm password does not match'
  //   }
  //   if (!values.phone) {
  //     errors.phone = 'Phone is required'
  //   }else if (!/^01[0125][0-9]{8}$/i.test(values.phone)) {
  //     errors.phone = 'Phone must be valid Eg-number'
  //   }
  //   return errors
  // }
  const [loading, setloading] = useState(false);
  const [errMsg, seterrMsg] = useState(null);
  let navigate = useNavigate();

  // Send Use data after validation
  async function handleRegister(values) {
    setloading(true);
    let { data } = await axios
      .post(`${baseURL}/api/v1/auth/signup`, values)
      .catch((err) => {
        console.log(err);
        setloading(false);
        seterrMsg(
          `${err.response.data.errors.param}: ${err.response.data.errors.msg}`
        );
      });
    if (data.message === "success") {
      setloading(false);
      navigate("/login");
    }
  }

  // Pattern of Inputs for Validation
  let validationSchema = Yup.object({
    name: Yup.string()
      .required("Name is Required")
      .min(3, "Name minlength is 3 chars")
      .max(10, "Name maxlength is 10 chars"),
    email: Yup.string()
      .required("Email is Required")
      .email("Invalid email address *exemple@yyy.zzz"),
    password: Yup.string()
      .required("Password is required")
      .matches(
        /^[A-Z][a-z0-9]{5,10}$/,
        "Password must start with Capital Letter includes at least 5 and less than 10 chars"
      ),
    rePassword: Yup.string()
      .required("Please reEnter Your Password")
      .oneOf([Yup.ref("password")], "Confirm password does not match"),
    phone: Yup.string()
      .required("Phone is required")
      .matches(/^01[0125][0-9]{8}$/, "Phone must be valid Eg-number"),
  });

  let formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      password: "",
      rePassword: "",
      phone: "",
    },
    validationSchema,
    onSubmit: handleRegister,
  });

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Sign UP for Free</title>
      </Helmet>
      <div className=" w-75 mx-auto py-4 ">
        <h3 className=" mb-3">Create new account</h3>

        <form onSubmit={formik.handleSubmit}>
          {errMsg ? <div className="alert alert-danger">{errMsg}</div> : null}

          {/* Handle Name Input with validation */}
          <label htmlFor="name">Name</label>
          <input
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.name}
            type="text"
            name="name"
            id="name"
            className=" form-control mb-2"
          />
          {formik.errors.name && formik.touched.name ? (
            <div className=" alert alert-danger">{formik.errors.name}</div>
          ) : null}

          {/* Handle Email Input with validation */}
          <label htmlFor="email">Email</label>
          <input
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.email}
            type="email"
            name="email"
            id="email"
            className=" form-control mb-2"
          />
          {formik.errors.email && formik.touched.email ? (
            <div className=" alert alert-danger">{formik.errors.email}</div>
          ) : null}

          {/* Handle Passwored with validation */}
          <label htmlFor="password">Password</label>
          <input
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.password}
            type="password"
            name="password"
            id="password"
            className=" form-control mb-2"
          />
          {formik.errors.password && formik.touched.password ? (
            <div className=" alert alert-danger">{formik.errors.password}</div>
          ) : null}

          {/* Handle RePassword with validation */}
          <label htmlFor="rePassword">rePassword</label>
          <input
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.rePassword}
            type="password"
            name="rePassword"
            id="rePassword"
            className=" form-control mb-2"
          />
          {formik.errors.rePassword && formik.touched.rePassword ? (
            <div className=" alert alert-danger">
              {formik.errors.rePassword}
            </div>
          ) : null}

          {/* Handle Phone Input with validation */}
          <label htmlFor="phone">Phone</label>
          <input
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.phone}
            type="tel"
            name="phone"
            id="phone"
            className=" form-control mb-2"
          />
          {formik.errors.phone && formik.touched.phone ? (
            <div className=" alert alert-danger">{formik.errors.phone}</div>
          ) : null}

          {/* Make Submit Button disabled till complete all requried data with validation check */}
          {loading ? (
            <button className="btn bg-main text-white mt-1" type="button">
              {" "}
              <i className="fa-solid fa-spinner fa-spin"></i>{" "}
            </button>
          ) : (
            <button
              disabled={!(formik.isValid && formik.dirty)}
              className="btn bg-main text-white mt-1"
              type="submit"
            >
              Register
            </button>
          )}

          {/* link to login if user has account */}
          <Link className="mt-2 hoveringClick d-block" to="/login">
            Already have an account? Sign in
          </Link>
        </form>
      </div>
    </>
  );
}
